'skip ssr';

import { getFirstSlug, mergeDocument, pagesTreeBfs, rebuildPagesTreeBasedOnSlugs } from 'website/src/lib/editor-utils';
import * as Y from 'yjs';
import { demoPagesMarkdown, faviconUrl } from 'website/src/lib/constants';
import { toTipTap } from 'website/src/lib/markdown-to-prosemirror';
import { paramToSlug } from 'website/src/lib/utils';
import { NextSeo } from 'next-seo';
import { env } from 'website/src/lib/env';
import { EditorsWithLayout } from 'website/src/components/editor/Editors';
export default function Page({}) {
  return <>
            <NextSeo {...{
      title: 'Online Markdown Editor - Holocron',
      description: `Holocron is an online markdown editor with an editable WYSIWYG preview. It can sync with GitHub, has real time collaboration, MDX support, AI integration and more.`,
      openGraph: {
        images: [{
          url: new URL(require('website/src/../public/markdown-editor-og-image.png').default.src, env.NEXT_PUBLIC_URL).toString()
        }]
      },
      twitter: {
        cardType: 'summary_large_image'
      },
      additionalLinkTags: [{
        rel: 'icon',
        href: faviconUrl
      }, {
        rel: 'apple-touch-icon',
        href: faviconUrl
        // sizes: '76x76',
      }]
    }} />
            <EditorsWithLayout />
        </>;
}
export async function getServerSideProps(ctx) {
  const start = new Date();
  const siteId = 'demo-project';
  const orgId = 'demo';
  const branchId = 'main';
  let slug = paramToSlug(ctx.params?.slug);
  const userId = '';
  let isPR = false;
  // isPR = true

  const pagesTree = demoPagesTree;

  // if (slug === '/' || !slug) {
  //     console.log('redirecting to first page', slug)
  //     const firstSlug = getFirstSlug(pagesTree)
  //     if (firstSlug)
  //         return {
  //             redirect: {
  //                 destination: demoProjectBasePath + firstSlug,
  //                 permanent: false,
  //             },
  //         }
  // }
  let page;
  if (!slug || slug === '/') {
    slug = getFirstSlug(pagesTree) || '';
  }
  pagesTreeBfs(pagesTree, node => {
    if (node.slug === slug) {
      page = node;
      return true;
    }
    return false;
  });
  if (!page) {
    console.log('demo page not found', slug);
    return {
      notFound: true
    };
  }
  const markdown = demoPagesMarkdown[slug];
  const documentBase64 = demoPagesBase64[slug];
  if (!documentBase64) {
    console.log(`no demo page found for ${slug}, ${JSON.stringify(Object.keys(demoPagesBase64))}`);
    return {
      notFound: true
    };
  }
  const freeTrialEndsInDays = 0;
  const access_token = '';
  const refresh_token = '';
  const pageId = page.pageId;
  const githubBranch = '';
  const githubRepo = '';
  const githubOwner = '';
  const installationId = 0;
  const pageSlug = page.slug;
  const websocketToken = '';
  const end = new Date();
  // console.log(
  //     'getServerSideProps took',
  //     (end.getTime() - start.getTime()) / 1000,
  //     'seconds',
  // )

  const siteBasePath = '/';
  const defaultBranchName = branchId;
  const siteName = 'Demo Project';
  const limits = {
    maxUsersNumber: 1
  };
  const props = {
    parseErrors: [],
    defaultEditorMode: 'split',
    allAssetPaths: [],
    projectType: 'demo-project',
    websocketToken,
    userId,
    isPR,
    siteBasePath,
    pagesTree,
    siteId,
    siteName,
    documentBase64,
    pageId,
    orgId,
    branchId,
    installationId,
    initialSession: null,
    githubOwner,
    githubRepo,
    githubBranch,
    orgs: [{
      name: 'Demo Org',
      orgId
    }],
    sites: [{
      name: siteName,
      orgId,
      siteId
    }],
    pageSlug,
    defaultBranchName,
    freeTrialEndsInDays,
    limits,
    subs: [],
    hasFreeTrial: false
  };
  return {
    props
  };
}
const demoPagesTree = rebuildPagesTreeBasedOnSlugs(Object.keys(demoPagesMarkdown).map(slug => {
  return {
    slug,
    pageId: `demo-project${slug}`
  };
}));
const demoPagesBase64 = Object.fromEntries(Object.entries(demoPagesMarkdown).map(([slug, md]) => {
  const doc = new Y.Doc();
  const {
    node,
    error
  } = toTipTap({
    str: md,
    pageSlug: slug
  });
  if (error) throw error;
  mergeDocument(doc, node, '.mdx');
  const buffer = Buffer.from(Y.encodeStateAsUpdate(doc));
  const base64 = buffer.toString('base64');
  return [slug, base64];
}));